import React from 'react';
import { NotificationMain } from './Index';
import { ContainerInline } from './NotificationStyles'
interface IProps{
    notificationIndicator: boolean,
    target: string
}
export class NotificationLink extends React.Component<IProps, {}> {
    constructor(props: any) {
        super(props);
    }
    public render() {
        return (
            <>
                {this.props.notificationIndicator && <ContainerInline>
                    <NotificationMain target={this.props.target} />
                </ContainerInline>}
            </>
        );
    }
}